// DIRECT SUPABASE CLIENT
// Use the direct client for reliable function calls in all environments

import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';
import { getSupabaseConfig } from './config';

const { url: SUPABASE_URL, publishableKey: SUPABASE_PUBLISHABLE_KEY } = getSupabaseConfig();

// Create direct Supabase client - works in both dev and production
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});

// Export Database type for backward compatibility
export type { Database };